import { Component } from '@angular/core';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import {
  ITherapistGroup,
  THERAPIST_GROUP_TTL_ES
} from '../../therapist-group.interface';
import { TherapistGroupService } from '../../therapist-group.service';

@Component({
  selector: 'pg-therapist-group',
  templateUrl: './therapist-group.component.html'
})
export class TherapistGroupComponent
  extends CrudTemplate
  implements ICrudTemplate
{
  constructor(private serviceBase: TherapistGroupService) {
    super(THERAPIST_GROUP_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: THERAPIST_GROUP_TTL_ES,
      columns: [{ header: 'Descripción', field: 'description' }]
      //
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: ITherapistGroup[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
